import differenceInMonths from 'date-fns/differenceInMonths';
import {CountFormatterOptions} from "./CountFormatterOptions";
import {createCountFormatter} from "../helpers";

export default class Doc {

    private foundKeywords: string[] = [];
    private transformedText: string = '';

    private dateStart: Date = new Date();
    private dateEnd: Date = new Date();

    constructor(
        public name: string,
        text: string,
        keywords: string[],
        public monthsTranslations: CountFormatterOptions,
        public yearsTranslations: CountFormatterOptions,
    ) {

        const regEx = new RegExp(`(${keywords.join('|')})([\,\s\t]+)*`, "ig");
        const replaceMask = '<span class="tech">$1</span>';

        const foundKeywords: string[] = [];
        keywords.forEach(x => {
            if (text.indexOf(x) > -1) {
                foundKeywords.push(x);
            }
        });

        this.foundKeywords = foundKeywords;
        this.transformedText = text.replace(regEx, replaceMask);
        this.transformedText = this.processDates(this.transformedText);
    }

    private processDates(text: string): string {

        const datePattern = /(?:<div class='dateRange'>)((([0-9]+)\/)?([0-9]+))(?:.*?)(((([0-9]+)\/)?([0-9]+))|Current)(?:<\/div>)/gmi;
        const dateRx = new RegExp(datePattern, "gmi");

        const txt1 = text.replace(datePattern, (match: string, ...matches): string => {

            const dates =
                Doc.getDatesFromMatches(matches, 2, 3, 7, 8, 4);

            this.dateStart = dates.dateStart;
            this.dateEnd = dates.dateEnd;

            return `<div class="years">${this.getTotalYearsAndMonths(this.dateStart, this.dateEnd)}</div>, ${match}`;
        });


        return txt1;
    }

    // private static getDates(text: string, datePattern: RegExp): {dateStart: Date, dateEnd: Date} {
    //
    //     const dateMatches = text.matchAll(datePattern);
    //
    //     let dateMatch: ReturnType<typeof dateMatches['next']>;
    //
    //     dateMatch = dateMatches.next();
    //
    //     if (dateMatch == null || dateMatch.value == [] || dateMatch.done == true) {
    //         return {dateStart: new Date(), dateEnd: new Date()};
    //     }
    //
    //     return this.getDatesFromMatches(dateMatch.value);
    // }

    private static getDatesFromMatches(matchesArray: string[], startMonthIndex: number, startYearIndex: number, endMonthIndex: number, endYearIndex: number, endCurrentWordIndex: number): {dateStart: Date, dateEnd: Date} {

        const dateStartTokens =
            [matchesArray[startMonthIndex], matchesArray[startYearIndex]]
                .filter(x => x != undefined)
                .map(x => parseInt(x));

        const dateStart = Doc.getDateFromTokens(dateStartTokens);

        let dateEnd: Date;
        if(matchesArray[endCurrentWordIndex] == 'Current'){
            dateEnd = new Date();
        }else{
            const dateEndTokens =
                [matchesArray[endMonthIndex], matchesArray[endYearIndex]]
                .filter(x => x != undefined)
                .map(x => parseInt(x));
            dateEnd = Doc.getDateFromTokens(dateEndTokens);
        }

        return {dateStart, dateEnd};
    }

    private static getDateFromTokens(numberTokens: number[]): Date {
        return numberTokens.length > 1 ?
            new Date(numberTokens[1], numberTokens[0] - 1) :
            new Date(numberTokens[0], 0);
    }

    public getTotalYearsAndMonths = (dateStart: Date, dateEnd: Date) => {



        const totalMonths = differenceInMonths(dateEnd, dateStart);

        const years = totalMonths / 12;

        // Округлять месяц в большую сторону
        const restMonths = Math.round((years%1)*12);
        const months = restMonths > 0 ? (12 - restMonths) : 0;

        const resultYears = Math.trunc(years);

        const yearFormatter = createCountFormatter(this.yearsTranslations);
        const monthFormatter = createCountFormatter(this.monthsTranslations);

        const resultYearsText = resultYears > 0 ? resultYears + ` ${yearFormatter(resultYears)} ` : '';

        return resultYearsText + (restMonths > 0 ? (restMonths + ` ${monthFormatter(restMonths)}`) : '');
    }

    private static processText = () => {

    }

    public getTransformedText = () => {
        return this.transformedText;
    }

    public getFoundKeywords = () => {

    }
}